import { WalletAccount } from '@exodus/models';
import { useSelector } from 'react-redux';

import type { ActivityEntry } from '../flux/tx-log/selectors/create-filtered-activity.js';
import createFilteredActivitySelector from '../flux/tx-log/selectors/create-filtered-activity.js';

const useActivity = ({
  assetNames,
  type = 'all',
  walletAccount = WalletAccount.DEFAULT_NAME,
}: {
  assetNames: string[];
  type?: string | string[];
  walletAccount?: string;
}) => {
  return useSelector(
    createFilteredActivitySelector({
      type,
      assetNames,
      walletAccounts: [walletAccount],
    }),
  ) as ActivityEntry[];
};

export default useActivity;
